import { createFileRoute, useLocation, useSearch } from '@tanstack/react-router';
import { useTheme, useMediaQuery } from '@mui/material';
import { useCallback } from 'react';
import {
  ContainerSelectionArgs,
  ContainerTypeLegacy,
  navigateTo,
  navigateToError,
  PileDashboard,
  useGetViewer,
} from '@amber-ui/core';

function PileDashboardRoute() {
  const { pathname } = useLocation();
  const theme = useTheme();
  // down('md') = < 960px, matches AuthLayout's mobile_width definition (width === 'sm' || 'xs').
  // Previously used down('sm') || only('xs') which was < 600px — inconsistent with AuthLayout.
  const matchesMobile = useMediaQuery(theme.breakpoints.down('md'));
  const mobile_width = matchesMobile;

  // Read pile ID from URL search params (source of truth)
  const { pile } = useSearch({ strict: false }) as { pile?: string };
  const { viewer } = useGetViewer();

  const pile_id = pile || null;

  const goCreateBarge = useCallback(() => {
    navigateTo('/barge/create');
  }, []);
  const goCreatePile = useCallback(() => {
    navigateTo('/pile/create');
  }, []);
  const goCreateGrainBin = useCallback(() => {
    navigateTo('/grain_bin/create');
  }, []);
  const goPileCableForm = useCallback(({ cable_id }: { cable_id: number }) => {
    navigateTo('/pile/cable', { cable_id });
  }, []);
  const onSelectContainer = useCallback((selected: ContainerSelectionArgs) => {
    if (selected.container_type === ContainerTypeLegacy.bin) {
      navigateTo('/grain_bin/dashboard', selected);
    } else if (selected.container_type === ContainerTypeLegacy.barge) {
      navigateTo('/barge/dashboard', selected);
    } else if (selected.container_type === ContainerTypeLegacy.pile) {
      navigateTo('/pile/dashboard', selected);
    }
  }, []);

  if (!viewer) return <div>Loading...</div>;

  return (
    <PileDashboard
      pile_id={pile_id}
      mobile_width={mobile_width}
      pathname={pathname}
      viewer={viewer}
      onError={() => {
        navigateToError();
      }}
      goPileCableForm={goPileCableForm}
      goCreatePile={goCreatePile}
      goCreateBarge={goCreateBarge}
      goCreateGrainBin={goCreateGrainBin}
      onSelectContainer={onSelectContainer}
    />
  );
}

export const Route = createFileRoute('/_auth/_pile/pile/dashboard')({
  component: PileDashboardRoute,
});
